import { css } from '@emotion/css';

import { AlignItems, BaseStyle, Color, Display, Font, Spacing } from '../../../../styles';

export const cardWrapper = css`
  background: ${Color.Gray1};
  box-shadow: 0rem 0.125rem 0.25rem rgba(2, 85, 163, 0.25);
  border-radius: 0.5rem;
  ${BaseStyle.clip}
  width: 100%;
  &:hover {
    box-shadow: 0 4px 12px 0 rgba(2, 85, 163, 0.25);
  }
  .ant-card-cover {
    ${BaseStyle.clip}
    width: 100%;
    ${BaseStyle.relative}
  }
  .ant-card-body {
    ${Spacing.p16}
  }
  .ant-card-meta-title {
    white-space: normal;
    ${Font.md}
  }
`;

export const featuredOfferName = css`
  font-weight: 600;
  ${Font.h4}
  min-height: 3.125rem;
  color: ${Color.Gray10};
  ${BaseStyle.clip}
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const minimalInvestment = css`
  font-weight: bold;
  ${Font.h4}
  color: ${Color.Orange6};
  min-height: 1.25rem;
`;

export const featuredOfferMedia = css`
  ${BaseStyle.relative}
  width: 100%;
`;

export const featuredOfferImage = css`
  ${Display.block}
  width: 100%;
  height: auto;
  object-fit: cover;
  object-position: 0 0;
  aspect-ratio: 21/9;
`;

export const divider = css`
  ${Display.block}
  height: 0.0625rem;
  border: 0;
  border-top: 0.0625rem solid #f2f5f7;
  ${Spacing.mt0}
  ${Spacing.mx0}
  ${Spacing.mb16}
`;

export const featuredOfferTags = css`
  && {
    position: absolute;
    left: 1rem;
    bottom: 1rem;
    z-index: 1;
    ${Display.flex}
    width: auto;
    height: auto;
    ${Spacing.m0}
  }
`;

// Note: duplicateed styles
export const accreditedInvestorsOnly = css`
  ${Display.flex}
  ${AlignItems.center}
`;

// Note: duplicateed styles
export const accreditedInvestorsOnlyText = css`
  ${Spacing.mr4}
`;
